export const HeaderPTBRTranslations = {
  header4iButtonLabel:
    'Navega para a página inicial e vai para o topo da página',
  headerMenuButtonLabel: 'Botão do menu',
};
